import { cover } from '../../../../../utility/constant/helper.constant'
import { useMontage } from '../../../../../context/montage.context'
import { Helper, Status, WindowElement } from '../../../../../classes/helper'
import { WindowsSideGlassBottom } from './glass/WindowsSideGlassBottom'
import { WindowsSideGlassTop } from './glass/WindowsSideGlassTop'
import { WindowsSideTie } from './tie/WindowsSideTie'
import { WindowsSideTieBottom } from './tie/WindowsSideTieBottom'
import { WindowsSideTieTop } from './tie/WindowsSideTieTop'
import { WindowsSideTieBack } from './tie/WindowsSideTieBack'
import { WindowsSideTieBottomBack } from './tie/WindowsSideTieBottomBack'

export const WindowsSideLeft = (): JSX.Element | null => {
  const { measure, sidewall } = useMontage()
  const option = WindowElement.optionsLeft(sidewall, measure)

  if (Status.sidewallLeft(sidewall)) return null

  return (
    <group
      position={[
        Helper.convertToMeter(-measure.userWidth + cover.bar.width),
        0,
        0,
      ]}
    >
      <WindowsSideTieBack />
      <WindowsSideGlassTop />
      <WindowsSideTie isGlass={option.isGlass} isSlanted={option.isSlanted} />
      {[...Array(option.windowsSideTotal)].map((_, index) => {
        return (
          <WindowsSideGlassBottom
            key={index}
            positionX={index}
            isGlass={option.isGlass}
            isSlanted={option.isSlanted}
          />
        )
      })}
      {[...Array(option.logsSideTotal)].map((_, index) => {
        return (
          <WindowsSideTieBottom
            key={index}
            positionX={index}
            isGlass={option.isGlass}
            isDoor={option.isDoor}
            isSlanted={option.isSlanted}
          />
        )
      })}
      {[...Array(option.tieNumberTop - 1)].map((_, index) => {
        return (
          <WindowsSideTieTop
            key={index}
            positionX={index}
            tieNumberTop={option.tieNumberTop}
          />
        )
      })}
      <WindowsSideTieBottomBack isGlass={option.isGlass} />
    </group>
  )
}
